export enum FolderScope {
  PERSONAL = 'PERSONAL',
  WORKSPACE = 'WORKSPACE',
}
